function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M61,45h-3V21c0-1.1044922-0.8955078-2-2-2H45V9c0-1.1044922-0.8955078-2-2-2H21c-1.1044922,0-2,0.8955078-2,2v6H9   c-1.1044922,0-2,0.8955078-2,2v28H3c-1.1044922,0-2,0.8955078-2,2v8c0,1.1044922,0.8955078,2,2,2h58c1.1044922,0,2-0.8955078,2-2   v-8C63,45.8955078,62.1044922,45,61,45z M11,19h8v18c0,1.1044922,0.8955078,2,2,2s2-0.8955078,2-2V11h18v16   c0,1.1044922,0.8955078,2,2,2s2-0.8955078,2-2v-4h9v22h-9V34c0-1.1044922-0.8955078-2-2-2s-2,0.8955078-2,2v11H23v-1   c0-1.1044922-0.8955078-2-2-2s-2,0.8955078-2,2v1h-8V19z M59,53H5v-4h4h12h22h13h3V53z",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29,28c-1.1044922,0-2,0.8955078-2,2s0.8955078,2,2,2h6c1.1044922,0,2-0.8955078,2-2s-0.8955078-2-2-2h-1V18   c0-0.7578125-0.4282227-1.4501953-1.1054688-1.7890625c-0.6782227-0.3388672-1.4882813-0.2666016-2.0947266,0.1894531l-3,2.25   c-0.8833008,0.6621094-1.0625,1.9160156-0.3999023,2.7998047c0.6142578,0.8173828,1.7348633,1.03125,2.6000977,0.5322266V28H29z",
  fill: "#FFFFFF"
}));

function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.611703f5.svg";
export { ForwardRef as ReactComponent };